export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'bb277c7f-7236-42a8-8ce9-3a7d4a52373a';
export const MODAL_CLOSE_SEC = 2.5;
